<mat-card class="policy-contract-entity-card">
  <mat-card-header>
    @if (showDeleteIcon()) {
      <button class="delete-icon" mat-icon-button (click)="this.iconClick.emit()" tabindex="-1">
        <mat-icon>close</mat-icon>
      </button>
    }
    <div class="header-container">
      <div>
        <mat-card-title
          (click)="this.titleClick.emit()"
          (keydown.enter)="$event.stopPropagation()"
          (keyup.space)="$event.stopPropagation()"
        >
          {{ getValue(cardConfig().title) | transloco }}
        </mat-card-title>
        <mat-card-subtitle>{{ getValue(cardConfig().subtitle) | truncate: 15 }}</mat-card-subtitle>
      </div>
      <img class="header-image" [src]="getImage()" alt="" />
    </div>
  </mat-card-header>

  <div class="divider-container">
    <mat-divider class="policy-contract-entity-card-divider"></mat-divider>
    <div class="divider-box"></div>
  </div>

  <mat-card-content>
    @for (cfg of finalCfg(); track cfg) {
      @if (creationDate()) {
        <div class="card-top-right-date">
          <span class="icon-time-span">
            <mat-icon>schedule</mat-icon>
            {{ creationDate() | relativeTime: 'N/A' }}
          </span>
        </div>
      }
      <div class="content-container">
        <div class="lable-container">
          <mat-icon>{{ getValue(cfg.icon!) }}</mat-icon>
          <span>{{ getValue(cfg.label!) | transloco }}</span>
        </div>
        <div class="propertie-container">
          @let value = cfg.value!(item());
          @switch (cfg!.type) {
            @case ('DATE') {
              <span>{{ asDate(value) | date: 'dd.MM.yyyy' }}</span>
            }
            @case ('LIST') {
              @let list = asList(value);
              <div class="list-container">
                @for (entry of list; track entry) {
                  <span>{{ entry }}</span>
                }
              </div>
            }
            @default {
              <span>{{ asString(value) }}</span>
            }
          }
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>
